import { render, staticRenderFns } from "./DeleteConceptSchemeConfirm.vue?vue&type=template&id=f2270ef2"
import script from "./DeleteConceptSchemeConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteConceptSchemeConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports